/* eslint-disable */
// @ts-nocheck

import { DocumentProps, PageProps } from '@react-pdf/types'

import Body from './report/Body'
import Layout from './report/Layout'

interface ReportProps {
  reportName: string
  headerData: Record<string, any>
  reportData: any[]
  reportSettings?: {
    document?: Partial<DocumentProps>
    page?: Partial<PageProps>
  }
  signLineTexts?: string[]
}

const Report = ({
  reportName,
  headerData,
  reportData,
  reportSettings,
  signLineTexts,
}: ReportProps) => {
  return (
    <Layout
      headerData={headerData}
      reportName={reportName}
      reportSettings={reportSettings}
      signLineTexts={signLineTexts}
    >
      <Body data={reportData} />
    </Layout>
  )
}

export default Report
